import { ApiClient } from "./client"

export class PersonProvider {
    private static _apiClient = new ApiClient();

    static async get(id: number) {
        return await this._apiClient.get(`/person/${id}`) as Person;
    }

    static async search(query: string) {
        return await this._apiClient.get(`/person/search?query=${encodeURIComponent(query)}`) as Person[];
    }

    static async getByIds(ids: number[]) {
        return await this._apiClient.get(`/person/by-ids?${ApiClient.encodeArray(ids, 'id')}`) as Person[];
    }

    static async matchByEmails(emails: string[]) {
        return await this._apiClient.get(`/person/by-emails?${ApiClient.encodeArray(emails, 'email')}`) as Person[];
    }

    static async save(person: Person) {
        return await this._apiClient.post('/person', person) as number;
    }
}

export interface Person {
    PersonId: number
    PersonOrganisationId: number
    PersonName: string
    PersonTitle: string
    PersonEmail: string
    PersonEmail2: string
    PersonDirectPhone: string
    PersonMobilePhone: string
    PersonImageFileExtension: string
    PersonUpdatedAt: string
    PersonUpdatedBy: string
    PersonCreatedAt: string
    PersonCreatedBy: string
    [prop: string]: any
}